export class ModalOptions {
  public width: string;
  public height: string;
  public data?: any;

  constructor(width: string, height: string, data?: any);

  constructor(options: ModalOptions);

  constructor(
    widthOrOptions: string | ModalOptions,
    height?: string,
    data?: any
  ) {
    if (typeof widthOrOptions === 'string') {
      this.width = widthOrOptions;
      this.height = height;
      this.data = data
    } else {
      Object.assign(this, widthOrOptions);
    }
  }
}

export class McRAIModalOptions extends ModalOptions { }
